import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Add, Close } from '@mui/icons-material';
import { Autocomplete, Button, IconButton, Modal, TextField, FormHelperText, Tabs, Tab } from '@mui/material';
import { Alert } from '@mui/material';
import Loading from "components/Loading";
import PageImagePicker from "components/AdminBooks/PageImagePicker";
import { Snackbar } from '@mui/material';
import styled from 'styled-components';
import { CaretDownOutlined } from '@ant-design/icons';
import { Col, Row, Dropdown } from 'antd';
import { DeleteModal } from 'components/Dialog';
import { cloneDeep } from 'lodash';
import { handleListExams, handleCreateExams, handleUpdateExams, handleDeleteExam } from 'store/exams/thunks';
import { handleListStandardExams, handleCreateStandardExams } from 'store/standardexams/thunks';
import { has } from 'lodash';
import { useExams } from 'store/exams/selectors';
import { useStandardExams } from 'store/standardexams/selectors';
import { find, map, get, groupBy } from "lodash";
import moment from "moment";
import dayjs from "dayjs";
import {
    DateTimePicker,
} from "@mui/x-date-pickers/DateTimePicker";
import { isBeforTime } from "utils/methods/math";
import EditStandardExamLevel from './StandardExam/EditStandardExam';
import ListStandardExam from './StandardExam/ListStandardExam';
import ExamList from './ExamList';


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------


export const Wrapper = styled.div`
    height: 100%;
    width: 100%;
`;

const ModalContent = styled.div`
  left: 50%;
  width: 70vw;
  padding: 0px 24px;
  position: absolute;
//   height:80vh;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: ${props => props.$overflow || 'auto'};
  margin-top: 10px;
`;
const TitleText = styled.span`
    font-size: 18px;
    color: black;
    font-weight:600;
    margin-left:5px;
    margin-top:5px;
`;

const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;


function isValidYearNextYearPattern(inputString) {
    const pattern = /^(\d{4})-(\d{4})$/;
    if (!pattern.test(inputString)) {
      return false;
    }
    const [, year, nextYear] = inputString.match(pattern);
    const yearNum = parseInt(year, 10);
    const nextYearNum = parseInt(nextYear, 10);
    return yearNum + 1 === nextYearNum;
  }
const getMinDate = (date1, date2) => {
    if (date1 && date2) {
        return isBeforTime(date1, date2) ? moment(date2).add(1, "minute").toISOString() : moment(date1).add(1, "minute").toISOString();
    } else if (date1 || date2) {
        return date1 ? moment(date1).add(1, "minute").toISOString() : moment(date2).add(1, "minute").toISOString();
    } else {
        return moment().toString()
    }
}

const EditExams = ({ open, close, data, booksAllList, exam, redirectToBook }) => {
    const [loading, setLoading] = useState(false)
    const [examData, setExamData] = useState()
    const dispatch = useDispatch()
    const onCreateOrUpdate = async () => {
        setLoading(true)
        const dt = cloneDeep(exam)
        if (examData && examData.id) {
            exam.exams.map((e, i) => {
                if (e.id === examData.id) {
                    dt.exams[i] = examData
                }
            })
            await dispatch(handleUpdateExams(dt))
        } else {
            let maxId = Math.max(...exam.exams.map(o => parseInt(o.id)))
            if (exam.exams.length == 0) {
                maxId = 1
            } else {
                if (isNaN(maxId) || maxId == -Infinity) {
                    maxId = 0;
                }
                maxId++;
            }
            dt.exams.push({ ...examData, id: maxId, order: maxId })
            await dispatch(handleUpdateExams(dt))
        }
        setLoading(false)
        close()
    }
    useEffect(() => {
        setExamData(data)
    }, [data])
    const isDisabled = !get(examData, "src") || !get(examData, "displayName") || !get(examData, "bookId")
    return (
        <Modal
            open={open}
            onClose={() => close()}
            style={{ height: '100%', width: '100%' }}
        >
            <ModalContent>
                <Row style={{ justifyContent: "space-between" }}>
                    <TitleText>
                        {data ? 'Update Exam' : 'Add Exam'}
                    </TitleText>
                    <IconButton onClick={() => close()} style={{ padding: 0, marginRight: 10 }}>
                        <Close color="secondary" />
                    </IconButton>
                </Row>
                <ModalConfigArea>
                    <Row>
                        <Col xs={24} lg={12} style={{marginBottom:20}}>
                            <PageImagePicker
                                src={get(examData, "src")}
                                path={`/exams`}
                                onChange={item => {
                                    setExamData({ ...examData, src: item.url })
                                }}
                                hasDescription={false}
                            />
                        </Col>
                        <Col xs={24} lg={12} style={{ paddingLeft: 10, paddingTop: 10 }}>
                            <Row justify="start" style={{ marginBottom: 20, }}>
                                <TextField
                                    id="displayName"
                                    name="displayName"
                                    label="Display name"
                                    required={false}
                                    InputLabelProps={{ shrink: true }}
                                    type="text"
                                    variant="outlined"
                                    onChange={e => {
                                        setExamData({ ...examData, displayName: e.target.value })
                                    }}
                                    value={get(examData, "displayName")}
                                />
                            </Row>
                            <Row
                                gutter={[24, 24]}
                                style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}
                                className='floatingLabelBG'
                            >
                                <Col span={24} style={{ paddingLeft: '0 !important' , paddingRight: '0 !important'}}>
                                  <Autocomplete
                                    id="bookId"
                                    options={booksAllList}
                                    getOptionLabel={(option) => `${option.description || ""} (${option.id || ""})`}
                                    value={booksAllList.find((bk) => bk.id === get(examData, "bookId")) || null}
                                    onChange={(event, newValue) => {
                                      setExamData({
                                        ...examData,
                                        bookId: newValue ? newValue.id : "",
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField {...params} label="Book" variant="outlined" fullWidth />
                                    )}
                                    fullWidth
                                  />
                                </Col>
                            </Row>
                            <Row gutter={[16, 24]} className="durDateSpc">
                                <Col span={24}>
                                    <DateTimePicker
                                        id="StartFrom"
                                        label="Start Date"
                                        slotProps={{
                                            textField: {
                                                variant: "outlined",
                                                InputLabelProps: {
                                                    shrink: true,
                                                }
                                            }
                                        }}
                                        format="MM-DD-YYYY hh:mm a"
                                        value={get(examData, "startDate") ? dayjs(get(examData, "startDate")) : dayjs()}
                                        onChange={e => {
                                            setExamData({
                                                ...examData,
                                                startDate: e ? e.toISOString() : null,
                                            });
                                        }} />
                                </Col>
                            </Row>
                            <Row gutter={[16, 24]} className="durDateSpc" style={{marginBottom:30}}>
                                <Col span={24}>
                                    <DateTimePicker
                                        id="ednFromDate"
                                        label="End Date"
                                        slotProps={{
                                            textField: {
                                                variant: "outlined",
                                                InputLabelProps: {
                                                    shrink: true,
                                                }
                                            }
                                        }}
                                        format="MM-DD-YYYY hh:mm a"
                                        minDateTime={get(examData, "startDate") ? dayjs(getMinDate(get(examData, "startDate"))) : null}
                                        value={get(examData, "endDate") ? dayjs(get(examData, "endDate")) : dayjs()}
                                        onChange={e => {
                                            setExamData({
                                                ...examData,
                                                endDate: e ? e.toISOString() : null,
                                            });
                                        }} />
                                </Col>
                            </Row>
                            <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                                <Button fullWidth
                                    onClick={onCreateOrUpdate}
                                    disabled={isDisabled}
                                    variant="contained" color="primary">
                                    {loading ? <Loading white size={15} /> : null}
                                    {data ? "Update" : "Create"}
                                </Button>
                            </Row>
                            {has(data, "id") ? <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                                <Button fullWidth
                                    onClick={() => {
                                        redirectToBook(examData.bookId)
                                    }}
                                    disabled={isDisabled}
                                    variant="contained" color="primary">
                                    Open book
                                </Button>
                            </Row> : null}
                        </Col>
                    </Row>
                </ModalConfigArea>
            </ModalContent>
        </Modal>
    );
};

const EditExamsLavel = ({ open, close, data, activeSession, examDSessionata, standard }) => {
    const [loading, setLoading] = useState(false)
    const [examData, setExamData] = useState()
    const dispatch = useDispatch()

    const handleClose = () => {
        close()
    }

    const onCreateOrUpdate = async () => {
        setLoading(true)
        try {
            if (examData && examData.id) {
                await dispatch(handleUpdateExams(examData))
            } else {
                const hasMiddle = find(examDSessionata, ['exam_school', 'middle'])
                await dispatch(handleCreateExams({ 
                    ...examData, 
                    exams: [], 
                    session: activeSession, 
                    exam_school: !hasMiddle ? 'middle' : '' 
                }))
            }
            close()
        } catch (err) {
            console.error('Error creating/updating exam level:', err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        setExamData(data)
    }, [data])

    const isDisabled = !get(examData, "displayName") || loading
    
    return (
        <Modal
            open={open}
            onClose={handleClose}
            style={{ height: '100%', width: '100%' }}
        >
            <ModalContent style={{ width: "45vw", maxWidth: '500px', height: "auto", padding: '24px', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)' }}>
                <Row style={{ justifyContent: "space-between", alignItems: "center", marginBottom: '24px' }}>
                    <TitleText style={{ fontSize: '20px', fontWeight: 600 }}>
                        {data ? 'Update Exam Level' : 'Add Exam Level'}
                    </TitleText>
                    <IconButton 
                        onClick={handleClose}
                        sx={{ 
                            padding: '4px',
                            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                        }}
                    >
                        <Close />
                    </IconButton>
                </Row>
                <ModalConfigArea $overflow="visible">
                    <Row>
                        <Col span={24}>
                            <div style={{ marginBottom: '24px' }}>
                                <TextField
                                    fullWidth
                                    id="displayName"
                                    name="displayName"
                                    label="Display Name"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    type="text"
                                    variant="outlined"
                                    onChange={e => {
                                        setExamData({ ...examData, displayName: e.target.value })
                                    }}
                                    value={get(examData, "displayName") || ''}
                                    helperText="Enter a name for this exam level"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '6px',
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '14px',
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ 
                                display: 'flex', 
                                gap: '12px', 
                                justifyContent: 'flex-end',
                                marginTop: '8px'
                            }}>
                                <Button
                                    onClick={handleClose}
                                    variant="outlined"
                                    disabled={loading}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '6px',
                                        minWidth: '100px',
                                        fontWeight: 500,
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={onCreateOrUpdate}
                                    disabled={isDisabled}
                                    variant="contained" 
                                    color="primary"
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '6px',
                                        minWidth: '120px',
                                        fontWeight: 500,
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                        '&:hover': {
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                        },
                                        '&:disabled': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.12)',
                                        }
                                    }}
                                >
                                    {loading ? <Loading white size={15} /> : (data ? "Update" : "Create")}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </ModalConfigArea>
            </ModalContent>
        </Modal>
    )
}

const EditSessions = ({ open, close, examSessionData }) => {
    const [loading, setLoading] = useState(false)
    const [session, setSessions] = useState('')
    const [error, setError] = useState(null)
    const dispatch = useDispatch()
    
    const currentYear = new Date().getFullYear()
    const exampleFormat = `${currentYear}-${currentYear + 1}`
    
    const handleClose = () => {
        close()
        setSessions('')
        setError(null)
    }
    
    const onCreateOrUpdate = async () => {
        const trimmedSession = session.trim()
        
        if (!trimmedSession) {
            setError('Session is required')
            return
        }
        
        if (examSessionData[trimmedSession]) {
            setError('This session already exists. Please add a different one.')
            return
        }
        
        if (!isValidYearNextYearPattern(trimmedSession)) {
            setError(`The input must follow the 'year-nextyear' pattern, e.g., '${exampleFormat}'`)
            return
        }

        setLoading(true)
        setError(null)
        
        try {
            await dispatch(handleCreateExams({ 
                displayName: 'High School Level', 
                exams: [], 
                session: trimmedSession, 
                exam_school: 'high' 
            }))
            close(trimmedSession)
        } catch (err) {
            setError('Failed to create session. Please try again.')
        } finally {
            setLoading(false)
        }
    }
    
    return (
        <Modal
            open={open}
            onClose={handleClose}
            style={{ height: '100%', width: '100%' }}
        >
            <ModalContent style={{ width: "45vw", maxWidth: '500px', height: "auto", padding: '24px' }}>
                <Row style={{ justifyContent: "space-between", alignItems: "center", marginBottom: '24px' }}>
                    <TitleText style={{ fontSize: '20px', fontWeight: 600 }}>
                        Add Exam Session
                    </TitleText>
                    <IconButton 
                        onClick={handleClose} 
                        sx={{ 
                            padding: '4px',
                            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                        }}
                    >
                        <Close />
                    </IconButton>
                </Row>
                
                <ModalConfigArea $overflow="visible">
                    <Row>
                        <Col span={24}>
                            {error && (
                                <Alert 
                                    severity="error" 
                                    sx={{ 
                                        marginBottom: '20px',
                                        borderRadius: '6px',
                                        '& .MuiAlert-message': {
                                            fontSize: '14px'
                                        }
                                    }}
                                    onClose={() => setError(null)}
                                >
                                    {error}
                                </Alert>
                            )}
                            
                            <div style={{ marginBottom: '24px' }}>
                                <TextField
                                    fullWidth
                                    id="session"
                                    name="session"
                                    label="Session Year"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    type="text"
                                    variant="outlined"
                                    placeholder={exampleFormat}
                                    value={session}
                                    onChange={e => {
                                        setSessions(e.target.value)
                                        setError(null)
                                    }}
                                    error={!!error}
                                    helperText={`Format: ${exampleFormat} (year-nextyear)`}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '6px',
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '14px',
                                        }
                                    }}
                                />
                            </div>
                            
                            <div style={{ 
                                display: 'flex', 
                                gap: '12px', 
                                justifyContent: 'flex-end',
                                marginTop: '8px'
                            }}>
                                <Button
                                    onClick={handleClose}
                                    variant="outlined"
                                    disabled={loading}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '6px',
                                        minWidth: '100px',
                                        fontWeight: 500,
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={onCreateOrUpdate}
                                    disabled={!session.trim() || loading}
                                    variant="contained" 
                                    color="primary"
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '6px',
                                        minWidth: '120px',
                                        fontWeight: 500,
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                        '&:hover': {
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                        },
                                        '&:disabled': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.12)',
                                        }
                                    }}
                                >
                                    {loading ? <Loading white size={15} /> : 'Create Session'}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </ModalConfigArea>
            </ModalContent>
        </Modal>
    )
}
const AssessmentContainer = ({
    booksAllList,
}) => {
  	const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [examDatam, setExamData] = useState([])
    const dispatch = useDispatch()
    const exams = useExams()
    // const exams = []

    const [selectExamType, setSelectExamType] = useState('Exam');
    const standardExams = useStandardExams()
    const [activeExamData, setActiveData] = useState();
    const [selectedExam, setSelectedExam] = useState();
    const [openEditExamModal, setOpenEditExamModal] = React.useState(false);

    const [openEditExamLevelModal, setOpenEditExamLevelModal] = React.useState(false);
    const [openEditStandardModal, setOpenEditStandardModal] = React.useState(false);

    const [deleteLodaing, setDeleteLoading] = useState(false)
    const [openDeleteExamModal, setOpenDeleteExamModal] = React.useState(false);
    const [activeSession, setActiveSession] = useState(null);
    const [examGroupData,setExamGroupData] = useState({})
    const [openAddSesion,setOpenAddSesion] = useState(false);
    const [state, setState] = React.useState({
        open: false,
        message: ""
    });
    const loadExams = async () => {
        setLoading(get(exams, "length") == 0)
        await dispatch(handleListExams())
        await dispatch(handleListStandardExams())
        setLoading(false)
    }
    useEffect(() => {
        loadExams()
    }, [])
    const redirectToBook = (bookId) => {
        navigate(`/add-book?bookId=${bookId}&pageId=1`)
    }
    useEffect(() => {
        //sort exam by order
        if (exams) {
            const sortedExams = exams.sort((a, b) => {
                if (a.order > b.order) {
                    return 1
                }
                if (a.order < b.order) {
                    return -1
                }
                return 0
            })
            const years = new Date().getFullYear();
            const grp = groupBy(sortedExams,"session")
            const upcomming_year = `${years}-${years+1}`;
            const downcomming_year = `${years-1}-${years}`;
            const upcomming = grp[upcomming_year]
            setExamGroupData(grp)
            if(activeSession&& grp[activeSession]){
                setExamData(grp[activeSession])
            }
            else if (upcomming) {
                setActiveSession(upcomming_year)
                setExamData(upcomming)
            } else if (grp[downcomming_year]) {
                setActiveSession(downcomming_year)
                setExamData(grp[downcomming_year])
            }else{
                const keys = Object.keys(grp)[0]
                setActiveSession(keys)
                setExamData(grp[keys])
            }
        }

    }, [exams])
    
    const handleClose = () => {
        setState({ open: false, message: "" });
    };
    const onAddExam = (exmDt, exm) => {
        setActiveData(exmDt)
        setSelectedExam(exm)
        setOpenEditExamModal(true)
    }
    const onAddEditExamLevel = (exm) => {
        setActiveData(exm)
        setOpenEditExamLevelModal(true)
    }

    const onAddEditStandardExam = (exm) => {
        setActiveData(exm)
        setOpenEditStandardModal(true)
    }

    const onClose = () => {
        setOpenEditExamModal(false)
        setActiveData(null)
        setSelectedExam(null)
        setOpenEditExamLevelModal(false);
        setOpenEditStandardModal(false);
    }
    const onSessionDataClosed = (session_id) => {
        setOpenAddSesion(false)
        if (session_id) {
            const allExams = [...(exams || []), ...(standardExams || [])];
            const grp = groupBy(allExams, "session")
            if (grp[session_id]) {
                setExamData(grp[session_id])
                setActiveSession(session_id)
            }
        }
    }
    const onDeleteExam = async () => {
        setDeleteLoading(true)
        await dispatch(handleDeleteExam(get(activeExamData, "id")))
        setActiveData(null)
        setOpenDeleteExamModal(false)
        setDeleteLoading(false)
    }
    const onSelectSession = (key) =>{
        setActiveSession(key)
        setExamData(examGroupData[key])
    }
    const menuData = () =>{
        return {
            items: map(Object.keys(examGroupData), x => ({
                key: x,
                label: (
                    <PaddedBtn onClick={()=>onSelectSession(x)}>{x}</PaddedBtn>
                ),
                style: { padding: '0px' }
            }))
        }
    }

    const onSelectExamType = (type) => {
        setSelectExamType(type);
    }
    const { open, message } = state;
    return (
      <Wrapper>
        {loading ? (
          <Loading />
        ) : (
          <>
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              open={open}
              autoHideDuration={3000}
              onClose={handleClose}
            >
              <Alert onClose={handleClose} severity="error">
                <strong>ALERT:</strong> {message}
              </Alert>
            </Snackbar>
            <DeleteModal
              deleteToggle={openDeleteExamModal}
              onDelete={onDeleteExam}
              message={`Are you sure you want to delete ${get(activeExamData, 'displayName', 'this Exam')}?`}
              setDeleteToggle={() => {
                setOpenDeleteExamModal(false);
              }}
              loading={deleteLodaing}
            />
            <EditExams
              data={selectedExam}
              open={openEditExamModal}
              close={onClose}
              exam={activeExamData}
              booksAllList={booksAllList}
              redirectToBook={redirectToBook}
            />
            <EditExamsLavel
              data={activeExamData}
              open={openEditExamLevelModal}
              examDSessionata={examDatam}
              activeSession={activeSession}
              close={onClose}
            />

            <EditStandardExamLevel
              data={activeExamData}
              open={openEditStandardModal}
              examDSessionata={examDatam}
              activeSession={activeSession}
              close={onClose}
              standard={true}
            />

            <EditSessions
              examSessionData={examGroupData}
              open={openAddSesion}
              close={onSessionDataClosed}
            />
            <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
              <Col span={24}>
                <div style={{
                  display: 'inline-block',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '8px',
                  padding: '4px',
                }}>
                  <Tabs
                    value={selectExamType === 'Exam' ? 0 : 1}
                    onChange={(e, newValue) => onSelectExamType(newValue === 0 ? 'Exam' : 'Standard Exam')}
                    sx={{
                      minHeight: 'auto',
                      '& .MuiTabs-indicator': {
                        height: '3px',
                        borderRadius: '3px 3px 0 0',
                        backgroundColor: '#1976d2',
                      },
                      '& .MuiTab-root': {
                        textTransform: 'none',
                        fontSize: '16px',
                        fontWeight: 500,
                        minHeight: '48px',
                        color: '#666',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          color: '#1976d2',
                          backgroundColor: 'rgba(25, 118, 210, 0.08)',
                        },
                      },
                      '& .Mui-selected': {
                        color: '#1976d2',
                        fontWeight: 700,
                        backgroundColor: '#ffffff',
                        borderRadius: '6px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <Tab 
                      label="Exam" 
                      sx={{
                        '&.Mui-selected': {
                          color: '#1976d2',
                        },
                      }}
                    />
                    <Tab 
                      label="Standard Exam"
                      sx={{
                        '&.Mui-selected': {
                          color: '#1976d2',
                        },
                      }}
                    />
                  </Tabs>
                </div>
              </Col>
            </Row>
            <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
              <Col span={24} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                {selectExamType === 'Exam' ? (
                  <>
                    <Dropdown menu={menuData()} placement="bottomLeft" trigger={['click']}>
                      <Button 
                        onClick={(e) => e.preventDefault()}
                        variant="outlined"
                        sx={{
                          textTransform: 'none',
                          borderRadius: '6px',
                          fontWeight: 500,
                          borderColor: '#d0d0d0',
                          color: '#333',
                          '&:hover': {
                            borderColor: '#1976d2',
                            backgroundColor: 'rgba(25, 118, 210, 0.04)',
                          },
                        }}
                      >
                        {activeSession ? activeSession : 'sessions'}
                        <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                      </Button>
                    </Dropdown>
                    <Button
                      onClick={() => setOpenAddSesion(true)}
                      color="primary"
                      variant="contained"
                      startIcon={<Add />}
                      sx={{
                        textTransform: 'none',
                        borderRadius: '6px',
                        fontWeight: 500,
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        '&:hover': {
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                        },
                      }}
                    >
                      Add session
                    </Button>
                    <Button
                      onClick={() => onAddEditExamLevel()}
                      color="primary"
                      variant="contained"
                      startIcon={<Add />}
                      sx={{
                        textTransform: 'none',
                        borderRadius: '6px',
                        fontWeight: 500,
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        '&:hover': {
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                        },
                      }}
                    >
                      Exam level
                    </Button>
                  </>
                ) : (
                  <Button
                    onClick={() => onAddEditStandardExam()}
                    color="primary"
                    variant="contained"
                    startIcon={<Add />}
                    sx={{
                      textTransform: 'none',
                      borderRadius: '6px',
                      fontWeight: 500,
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                      '&:hover': {
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                      },
                    }}
                  >
                    Standard Based Exam
                  </Button>
                )}
              </Col>
            </Row>
            {selectExamType === 'Exam' ? (
              <ExamList
                examDatam={examDatam}
                onAddExam={onAddExam}
                onAddEditExamLevel={onAddEditExamLevel}
                setOpenDeleteExamModal={setOpenDeleteExamModal}
                setActiveData={setActiveData}
              />
            ) : (
              <ListStandardExam booksAllList={booksAllList} />
            )}
          </>
        )}
      </Wrapper>
    );
};

//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({
    currentUser: state.currentUser,
    classActivities: state.classActivities,
    classQuizzes: state.classQuizzes,
    booksAllList: state.booksAllList
});

export default connect(mapStateToProps, null)(AssessmentContainer);